__turbopack_context__.v({
  "backdrop": "STModal-module__jUUWaq__backdrop",
  "body": "STModal-module__jUUWaq__body",
  "btnPrimary": "STModal-module__jUUWaq__btnPrimary",
  "btnSecondary": "STModal-module__jUUWaq__btnSecondary",
  "close": "STModal-module__jUUWaq__close",
  "container": "STModal-module__jUUWaq__container",
  "fadeIn": "STModal-module__jUUWaq__fadeIn",
  "footer": "STModal-module__jUUWaq__footer",
  "header": "STModal-module__jUUWaq__header",
  "overlay": "STModal-module__jUUWaq__overlay",
  "title": "STModal-module__jUUWaq__title",
});
